export default "__VITE_ASSET__cc14db25__"